import { render } from "./PopupCloseButton.vue?vue&type=template&id=8fe6afa4&scoped=true"
const script = {}

import "./PopupCloseButton.vue?vue&type=style&index=0&id=8fe6afa4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fe6afa4"]])

export default __exports__